import React from 'react';

const ChatBubble = ({ message, type }) => (
    <div className={`flex ${type === 'user' ? 'justify-end' : 'justify-start'} mb-4`}>
      <div className={`max-w-[80%] rounded-2xl px-4 py-2 ${
        type === 'user' 
          ? 'bg-indigo-600 text-white rounded-tr-none' 
          : 'bg-gray-800/80 text-white rounded-tl-none'
      }`}>
        <p className="text-sm md:text-base">{message}</p>
      </div>
    </div>
  );
  
  const ChatSimulation = () => {
    const [messages, setMessages] = React.useState([]);
    const [isComplete, setIsComplete] = React.useState(false);
    const chatRef = React.useRef(null);
  
    const conversation = [
      { type: 'user', message: "Hi! What's the check-in process for the apartment?" },
      { type: 'ai', message: "Welcome! Check-in is super easy. You'll receive a unique QR code 24 hours before your arrival. Simply scan it at the main entrance and your apartment door. The code works from 3 PM on your check-in date. Need help with anything else? 😊" },
      { type: 'user', message: "Is there parking available nearby?" },
      { type: 'ai', message: "Yes! You have a dedicated parking spot (#15) in the underground garage. I'll send you the garage door code on the morning of your arrival. There's also street parking and a public garage two blocks away if you have additional vehicles. 🚗" },
      { type: 'user', message: "Great! And what's the WiFi password?" },
      { type: 'ai', message: "Network: ShortStai-Guest\nPassword: Welcome2024!" }
    ];
  
    React.useEffect(() => {
      let currentIndex = 0;
      const maxMessages = conversation.length;
      let isActive = true;
  
      const timer = setInterval(() => {
        if (currentIndex < maxMessages && isActive) {
          setMessages(prev => [...prev, conversation[currentIndex]]);
          currentIndex++;
  
          if (chatRef.current) {
            chatRef.current.scrollTop = chatRef.current.scrollHeight;
          }
  
          if (currentIndex === maxMessages) {
            setIsComplete(true);
            clearInterval(timer);
          }
        }
      }, 2000);
  
      return () => {
        isActive = false;
        clearInterval(timer);
      };
    }, []);
  
    return (
      <div className="bg-gray-900/50 backdrop-blur-sm rounded-2xl border border-gray-800/50 p-4 w-full">
        {/* Chat Header */}
        <div className="flex items-center justify-between mb-4 pb-4 border-b border-gray-800/50">
          <div className="flex items-center">
            <div className="w-3 h-3 bg-green-500 rounded-full mr-2"></div>
            <span className="text-white font-medium">ShortStai AI Assistant</span>
          </div>
          <div className="text-gray-400 text-sm">Always online</div>
        </div>
  
        {/* Chat Messages */}
        <div 
          ref={chatRef}
          className="h-[400px] overflow-y-auto space-y-4 mb-4 scrollbar-thin scrollbar-thumb-gray-800 scrollbar-track-transparent p-4"
        >
          {messages.filter(msg => msg && msg.type).map((msg, index) => (
            <div 
              key={index} 
              className={`flex ${msg.type === 'user' ? 'justify-end' : 'justify-start'} mb-4`}
            >
              <div 
                className={`max-w-[80%] rounded-2xl px-4 py-2 ${
                  msg.type === 'user' 
                    ? 'bg-indigo-600 text-white rounded-tr-none' 
                    : 'bg-gray-800/80 text-white rounded-tl-none'
                }`}
              >
                <p className="text-sm md:text-base whitespace-pre-line">{msg.message}</p>
              </div>
            </div>
          ))}
        </div>
  
        {/* Chat Input */}
        <div className="flex items-center gap-2">
          <input
            type="text"
            placeholder={isComplete ? "Ask anything about your stay..." : "Loading conversation..."}
            disabled={!isComplete}
            className="w-full px-4 py-2 bg-gray-800/50 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-indigo-500"
          />
          <button 
            className={`px-4 py-2 bg-indigo-600 text-white rounded-lg flex items-center justify-center ${
              !isComplete ? 'opacity-50 cursor-not-allowed' : 'hover:bg-indigo-700'
            }`}
            disabled={!isComplete}
          >
            Send
          </button>
        </div>
      </div>
    );
  };
  
  export default ChatSimulation;